import Notification from '@/components/Notification';

import styles from './index.module.scss';
import {IMeetingInfo} from '@/utils/document/meetingMode';
import {dateFormat} from '@/utils/dateUtils';
import {useIntl} from 'react-intl';

interface IProps {
    meetingInfo: IMeetingInfo;
}

function MeetingTip({meetingInfo}: IProps) {
    const intl = useIntl();

    const {creatorUser, createTime} = meetingInfo || {};

    return (
        <div className={styles.notification}>
            <Notification
                type="info"
                content={<span>
                    {
                        `文档已启动协作模式 / ${creatorUser?.name}${dateFormat(createTime, intl)}发起`
                    }
                </span>}
            />
        </div>
    );
}

export default MeetingTip;
